import { fromJS } from 'immutable'

import { LINK_POST, LINK_UPDATE, LINK_ERROR } from 'actions/link'

// Reducer
// ---------------------------------------------------------------------------

export const initialState = fromJS({
  error: false,
  errorData: null,
  loading: false,
  returnData: null,
})

export default function createLinkReducer(state = initialState, action) {
  switch (action.type) {
    case LINK_POST:
      return _postLink(state)
    case LINK_UPDATE:
      return _updateLink(state, action.payload)
    case LINK_ERROR:
      return _errorLink(state, action.payload)
    default:
      return state
  }
}

const _postLink = state => {
  return state.update('loading', () => true)
}

const _updateLink = (state, payload) => {
  return state
    .set('returnData', fromJS(payload.data))
    .update('loading', () => false)
    .update('error', () => false)
    .update('errorData', () => null)
}

const _errorLink = (state, payload) => {
  return state
    .set('error', payload.error)
    .set('errorData', fromJS(payload.data))
    .update('loading', () => false)
}
